import Api from '@/services/api.js'

export default {
  addBill(bill) {
    return Api.post('bills/add', bill)
  },
  addBills(bills) {
    return Api.post('bills/addMultiple', bills)
  },
  getAllBills() {
    return Api.get('bills')
  },
  getBills(payload) {
    return Api.post('bills/getBy', payload)
  },
  getBillsByBillingPeriod(billingPeriod) {
    return Api.get(`bills/byBillingPeriod/${billingPeriod}`)
  },
  getConfirmedBills() {
    return Api.get('bills/confirmed')
  },

  getUnConfirmedBills() {
    return Api.get('bills/unconfirmed')
  },

  getFinalisedBills() {
    return Api.get('bills/finalised')
  },
  updateBill(bill) {
    return Api.put(`bills/${bill.id}`, bill)
  },
  updateBills(ids) {
    return Api.patch(`bills/bills`, ids)
  },
  deleteBill(id) {
    return Api.delete(`bills/delete/${id}`)
  },
  deleteBills(obj) {
    return Api.post(`bills/deleteMultiple`, obj)
  },
  getExportBills(billingPeriod) {
    return Api.post(`bills/getExportBills/${billingPeriod}`)
  }

  // checkDocket(docket) {
  //     return Api.post('dockets/checkDocket', docket);
  // },
  // updateDocket(docket) {
  //     var id = docket.id;
  //     return Api.put(`dockets/${id}`, docket);
  // },
  // getAllDockets() {
  //     return Api.get('dockets/');
  // },
  // deleteAllDockets() {
  //     return Api.delete('dockets/');
  // },
}
